import { VStack } from '@chakra-ui/react';
import ContentReactions from '@/modules/content/feed/ContentReactions';
import ArticleBody from '@/modules/content/feed/reader/parts/ArticleBody';
import PostBody from '@/modules/content/feed/reader/parts/PostBody';
import VideoBody from '@/modules/content/feed/reader/parts/VideoBody';
import { readReaderDetails } from '@/modules/content/feed/reader/model/articleStructure';
import { TContent } from '@/types/Content.types';

// Reader experience for a content item — a per-type body plus the reactions footer.
// Reached from the article route and from any direct link.
const ContentReader = ({ content }: { content: TContent }) => {
  const details = readReaderDetails(content);

  return (
    <VStack align="stretch" width="100%" maxWidth="820px" gap="20px">
      {content.type === 'article' && <ArticleBody content={content} details={details} />}
      {content.type === 'post' && <PostBody content={content} details={details} />}
      {content.type === 'video' && <VideoBody content={content} details={details} />}

      <ContentReactions content={content} />
    </VStack>
  );
};

export default ContentReader;
